import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonItem,
  IonLabel,
  IonInput,
  IonButtons,
  IonBackButton,
  IonAlert,
  IonSpinner,
} from '@ionic/react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, signup } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        await login(email, password);
      } else {
        await signup(email, password, displayName || undefined);
      }
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/home" />
          </IonButtons>
          <IonTitle>{isLogin ? 'Sign In' : 'Sign Up'}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        <div className="login-container">
          <div className="login-header">
            <h1>🪙 Coin Collector</h1>
            <p>{isLogin ? 'Welcome back!' : 'Create your account'}</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <IonItem>
              <IonLabel position="stacked">Email</IonLabel>
              <IonInput
                type="email"
                value={email}
                onIonInput={(e) => setEmail(e.detail.value!)}
                placeholder="your@email.com"
                required
              />
            </IonItem>

            {!isLogin && (
              <IonItem>
                <IonLabel position="stacked">Display Name (Optional)</IonLabel>
                <IonInput
                  type="text"
                  value={displayName}
                  onIonInput={(e) => setDisplayName(e.detail.value!)}
                  placeholder="Your name"
                />
              </IonItem>
            )}

            <IonItem>
              <IonLabel position="stacked">Password</IonLabel>
              <IonInput
                type="password"
                value={password}
                onIonInput={(e) => setPassword(e.detail.value!)}
                placeholder="Enter password"
                required
              />
            </IonItem>

            <IonButton
              expand="block"
              type="submit"
              color="primary"
              className="submit-button"
              disabled={loading}
            >
              {loading ? <IonSpinner name="crescent" /> : (isLogin ? 'Sign In' : 'Sign Up')}
            </IonButton>
          </form>

          <div className="login-footer">
            <IonButton
              fill="clear"
              onClick={() => setIsLogin(!isLogin)}
            >
              {isLogin
                ? "Don't have an account? Sign Up"
                : 'Already have an account? Sign In'}
            </IonButton>
          </div>

          <div className="login-note">
            <p>🔒 Your data is secure and encrypted</p>
          </div>
        </div>

        <IonAlert
          isOpen={!!error}
          onDidDismiss={() => setError('')}
          header="Error"
          message={error}
          buttons={['OK']}
        />
      </IonContent>
    </IonPage>
  );
};

export default Login;

